import api from '../../api-request'
// 获取当前登陆用户信息
function getLoginUser () {
  return api.get('/traffic/user')
}

// 获取开通了消息存档的内部员工列表
function getCovUsers (params, data) {
  return api.post('/traffic/get/users/byDataScope', params, {
    params: data
  })
}
//新版获取开通了消息存档的内部员工展示离职和开启会话存档列表
function getWithDimCovUsers (params) {
  return api.post('/traffic/get/users/withDim/byDataScope', params)
}

// iframe 下获取员工列表
function getCovUsersByIframe (params) {
  return api.post('/chat-session/userList/get/user/byContactIds', params)
}


// 获取权限范围内的员工
function getChatUsersbyPermission (params) {
  return api.get(`/traffic/get/chatUsers/byPermission`, {params})
}
export default {
  getLoginUser,
  getCovUsers,
  getWithDimCovUsers,
  getCovUsersByIframe,
  getChatUsersbyPermission,
}
